export const CLIENT_DATE_FORMAT = 'dd.MM.yyyy';
export const DATE_FORMAT_TO_DB = 'yyyy-MM-dd H:mm:ss.SSSS';
